(($) => {
  $(document).ready(() => {
    const menu1 = () => {
      const menuHeader = $('#menu-header');
      const toggleButton = menuHeader.find('.toggle-menu')

      toggleButton.click(() => {
        menuHeader.toggleClass('active')
        toggleButton.toggleClass('active')
      })
    }
    const menu2 = () => {
      const menuHeader = $('#top-bar');
      const toggleButton = menuHeader.find('.toggle-menu')

      toggleButton.click(() => {
        menuHeader.toggleClass('active')
        toggleButton.toggleClass('active')
      })
    }

    menu1()
    menu2()
  })
})(jQuery)
